import * as React from "react";
import AboutColor from "../containers/AboutColor";
import blueQuotation from "../containers/AboutColor/blueQuotation";
import blueParrot from "../containers/AboutColor/blueParrot.png";
import COLOR_TYPES from "../common/colors/type";
import t from "../translations";

export default (props) => (
  <AboutColor
    {...props}
    authorName={t("routes_BlueAboutColorsPageRoute_autorName")}
    title={t("routes_BlueAboutColorsPageRoute_title")}
    image={blueParrot}
    quotation={blueQuotation}
    colorType={COLOR_TYPES.BLUE}
  />
);
